import { lazy } from "react";

import * as Global from "../../global";

const { Layout, Loading } = Global;

const NoPage = lazy(() => import("../../global/pages/errors/NoPage"));

export { Layout, Loading, NoPage };
